import {
  CtaReferenceContentAllowed,
  CtaReferenceProps,
} from "components/CtaReference/types";
import { ExtraBannerProps, ExtraLinkProps, MenuBaseItemProps } from "../types";
import {
  GeneralSmallArrowLeft,
  GeneralSmallChevronRight,
} from "@wise-emotions/react-icons";
import { useMenu } from "utilities/MenuProvider";
import CtaContent from "components/CtaContent";
import IconWrap from "components/Icon/IconWrap";
import MenuNav from "./MenuNav";
import React, { useEffect, useState } from "react";
import cn from "classnames";
import dictionary from "configs/dictionary";
import recursiveRender from "utilities/recursiveRender";

const ExtraLink = ({ data }: ExtraLinkProps) => {
  // TODO: create a type on dictionary
  const ComponentLink =
    dictionary.ContentfulCtaReferenceV2 as React.ElementType;

  return (
    <div className="menuItem-MenuBaseItem__extra-link">
      <div className="menuItem-MenuBaseItem__extra-link__list">
        {data.map((el: CtaReferenceProps<CtaReferenceContentAllowed>) => {
          return (
            <div
              className="menuItem-MenuBaseItem__extra-link__item"
              key={el.id}
            >
              <ComponentLink
                {...el}
                className="menuItem-MenuBaseItem__extra-link__link"
              >
                <CtaContent {...el?.content?.[0]} />
                <div className="menuItem-MenuBaseItem__extra-link__arrow">
                  <IconWrap>
                    <GeneralSmallChevronRight />
                  </IconWrap>
                </div>
              </ComponentLink>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const ExtraBanner = ({ data }: ExtraBannerProps) => {
  return (
    <div className="menuItem-MenuBaseItem__extra-banner">
      {recursiveRender({ cfComponent: data })}
    </div>
  );
};

const MenuBaseItem = ({
  data,
  currentLevel = 0,
  nextMenuMobile,
  hasSubmenu = false,
  drowSubmenu,
}: MenuBaseItemProps) => {
  // TODO: create a type on dictionary
  const ComponentLink =
    dictionary.ContentfulCtaReferenceV2 as React.ElementType;
  const { pageReference, content, extraLinks, extraBanner } = data;

  const menuHelpers = useMenu();
  const { backMenuMobile } = menuHelpers;

  const [drowMenu, setDrowMenu] = useState(false);

  useEffect(() => {
    if (drowSubmenu) {
      setDrowMenu(true);
    }
  }, [drowSubmenu]);

  const itemClass = cn("menuItem__link");

  const accessibility = {
    accessibility: {
      "aria-haspopup": hasSubmenu ? "true" : "false",
      "aria-expanded": "false",
      tabindex: "0",
      role: "menuitem",
    },
  };

  // NOTE: used only in commented LINK AUTOMATICO MENU MOBILE in menuNav
  // const parentPage = {
  //   pageReference,
  //   label: "tutti i servizi",
  // };

  const pageReferenceProps = { ...pageReference, ...accessibility };

  return (
    <>
      <ComponentLink
        {...pageReferenceProps}
        onClick={nextMenuMobile}
        className={itemClass}
      >
        {hasSubmenu && (
          <div className="menuItem__nextIcon">
            <IconWrap>
              <GeneralSmallChevronRight />
            </IconWrap>
          </div>
        )}
        <CtaContent {...pageReference.content[0]} />
      </ComponentLink>

      {content !== null &&
        content.length > 0 &&
        content.map((el) => {
          return (
            <MenuNav
              menu={el}
              currentLevel={currentLevel + 1}
              // NOTE: used only in commented LINK AUTOMATICO MENU MOBILE in menuNav
              // parentPage={parentPage}
              key={el.id}
              drowSubmenu={drowMenu}
              buttonBack={
                <button
                  // TODO: add correct aria label ( not hardcoded value )
                  aria-label="Back menu"
                  className="menuNav__breadcrumb"
                  onClick={backMenuMobile}
                  type="button"
                >
                  <div className="menuNav__breadcrumb__icon">
                    <IconWrap>
                      <GeneralSmallArrowLeft />
                    </IconWrap>
                  </div>
                  <div className="menuNav__breadcrumb__value">
                    {/* NOTE: static olny for this version  */}
                    {pageReference.node_locale === "it" ? "Indietro" : "Back"}
                  </div>
                </button>
              }
            >
              {extraBanner !== null && extraBanner.length > 0 && (
                <ExtraBanner data={extraBanner} />
              )}
              {extraLinks !== null && extraLinks.length > 0 && (
                <ExtraLink data={extraLinks} />
              )}
            </MenuNav>
          );
        })}
    </>
  );
};

export default MenuBaseItem;
